import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'refresh',
  `
    UPDATE_RESOURCE_VERSION
  `
);
